import './index.scss';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPersonImageAttach, convertImageToBase64, renderAnswer } from '@utils';
import { questionnaireRendererDataSelector } from '@selectors/questionnaire';
import { answerEnvironmentSelector } from '@selectors/answerEnvironmentSelector';
import { setAnswerAttachments } from '@actions/answerEnvironmentActions';
import { ImageLoader } from '@sharedComponents/ImageLoader/ImageLoader';
import { generateInitialsAvatar } from '@utils';
import { UserEntityInterface } from '@types';
import { LangEnum, ImageShape } from '@enums';

export const QPreview = () => {
  const dispatch = useDispatch();
  const questionnaireRendererData = useSelector(questionnaireRendererDataSelector);
  const env = useSelector(answerEnvironmentSelector);
  const lang = env.lang;
  useEffect(() => {
    renderAnswer(env, questionnaireRendererData, '#answer-preview');
  }, [env]);

  const handleOnImageLoad = (event, id) => {
    dispatch(
      setAnswerAttachments([
        ...env.attachments,
        createPersonImageAttach(id, {
          [ImageShape.SQUARE]: convertImageToBase64(event.target, ImageShape.SQUARE),
          [ImageShape.CIRCLE]: convertImageToBase64(event.target, ImageShape.CIRCLE),
        }),
      ])
    );
  };

  const handleOnImageError = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
    user: UserEntityInterface
  ) => {
    const initials = lang === LangEnum.RU ? user?.fullNameRu : user?.fullNameEng;
    const squareAvatar = generateInitialsAvatar(initials, ImageShape.SQUARE);
    const circleAvatar = generateInitialsAvatar(initials, ImageShape.CIRCLE);
    dispatch(
      setAnswerAttachments([
        ...env.attachments,
        createPersonImageAttach(user.id, {
          [ImageShape.SQUARE]: squareAvatar,
          [ImageShape.CIRCLE]: circleAvatar,
        }),
      ])
    );
  };

  return (
    <div>
      <ImageLoader
        userId={env.owner.id}
        onLoad={(event) => handleOnImageLoad(event, env.owner.id)}
        onError={(event) => handleOnImageError(event, env.owner)}
      />
      <div id="answer-preview" className="answer-preview"></div>
    </div>
  );
};
